import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';

import {
    startObserving,
    stopObserving,
    removeObservedEvents,
} from '~SpectateStore/actions/eventObserversActions';
import { eventInplayStart } from '~SpectateStore/actions/eventInplayStart';

const setByObserverMapping = (state) => {
    return state.ids.reduce((acc, eventId) => {
        const { observedBy } = state.entities[eventId];
        observedBy.forEach((observer) => {
            if (!acc[observer]) {
                acc[observer] = [];
            }
            acc[observer].push(eventId);
        });

        return acc;
    }, {});
};

export const eventObserversAdapter = createEntityAdapter();

const eventObservers = createSlice({
    name: 'eventObservers',
    initialState: eventObserversAdapter.getInitialState({
        byObserver: {},
    }),
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                startObserving,
                (state, { payload: { eventIds, observer } }) => {
                    eventIds.forEach((eventId) => {
                        if (!state.entities[eventId]) {
                            state.entities[eventId] = {
                                id: eventId,
                                observedBy: [observer],
                            };
                        }

                        if (!state.entities[eventId].observedBy.includes(observer)) {
                            state.entities[eventId].observedBy.push(observer);
                        }
                    });
                    state.ids = Object.keys(state.entities);
                    state.byObserver = setByObserverMapping(state);
                }
            )
            .addCase(
                stopObserving,
                (state, { payload: { observer } }) => {
                    if (!observer) {
                        return;
                    }

                    const eventIds = state.byObserver[observer] || [];
                    eventIds.forEach((eventId) => {
                        if (!state.entities[eventId]) {
                            return;
                        }

                        const entity = state.entities[eventId];
                        entity.observedBy = entity.observedBy.filter(
                            entityObserver => entityObserver !== observer
                        );
                    });

                    state.byObserver = setByObserverMapping(state);
                },
            )
            .addCase(
                eventInplayStart,
                (state, { payload: { preplayToInplayMapping } }) => {
                    // we need to copy over the event interest from its pre-play entity
                    Object.entries(preplayToInplayMapping).forEach(
                        ([preplayEventId, inplayEventId]) => {
                            const preplayEventObserver = state.entities[preplayEventId];
                            if (!preplayEventObserver) {
                                return;
                            }

                            state.entities[inplayEventId] = {
                                ...preplayEventObserver,
                                id: String(inplayEventId),
                            };
                        }
                    );

                    state.ids = Object.keys(state.entities);
                    state.byObserver = setByObserverMapping(state);
                }
            )
            .addCase(
                removeObservedEvents,
                (state, { payload: eventIds }) => {
                    eventObserversAdapter.removeMany(state, eventIds);
                    state.byObserver = setByObserverMapping(state);
                },
            );
    },
});

export default eventObservers.reducer;
